import  { DSR_ACCESS_TOKEN } from '@/store/constants/global'
import { authState } from '@/services/AuthService';

export default {
  name: 'Callback',
  async mounted() {
    try {
      // Auth0クライアントが初期化されているか確認
      if (authState.auth0Client) {
        // IDトークンを取得
        const idToken = await authState.auth0Client.getIdTokenClaims();
        
        if (idToken) {
          // IDトークンの__rawプロパティにトークン文字列が含まれています
          const rawIdToken = idToken.__raw;
          
          // localStorageにトークンを保存
          localStorage.setItem(DSR_ACCESS_TOKEN, rawIdToken);
          console.log('ID token saved to localStorage with key DSR_ACCESS_TOKEN');

          // 社員としてログインし直したため、残留している契約社員トークンを削除する
          // （残っていると契約社員トークンが優先され、別ユーザーとしてAPIを呼んでしまう）
          localStorage.removeItem('contractor_token');
          localStorage.removeItem('contractor_email');
        } else {
          console.error('Failed to get ID token');
        }
      } else {
        console.error('Auth0 client not initialized');
      }
    } catch (error) {
      console.error('Error getting ID token:', error);
    }
    
    // コールバックページがマウントされたら、ホームページにリダイレクト
    // Auth0の認証処理はAuthService.jsのinitAuth関数で処理されます
    setTimeout(() => {
      this.$router.push('/');
    }, 1000);
  }
};
